<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col cols="8">
                    <h1 class="headline font-weight-light mb-3">
                        <span
                            @click="back()"
                            :class="form != '' ? 'cursor' : ''"
                            >FORM ISSUE - TRANSFER</span
                        >
                        <span v-if="form != ''"> / {{ form }}</span>
                    </h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="form == ''">
                <v-col cols="10" sm="5" md="3" v-if="team_name !== 'ODM'">
                    <v-card @click="get_issue()">
                        <v-card-text>
                            <v-container>
                                <h1>ISSUE</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="5" v-if="team_name !== 'ODM'">
                    <v-card @click="get_transfer()">
                        <v-card-text>
                            <v-container>
                                <h1>TRANSFER TO BRANCH</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="4">
                    <v-card @click="get_transfer_ce()">
                        <v-card-text>
                            <v-container>
                                <h1>TRANSFER TO CE</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <FormIssuTranfer
                v-if="form != ''"
                :form="form"
                @index_page="index_page()"
            />
        </v-container>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import FormIssuTranfer from "./components/FormIssuTranfer"

export default {
    components: {
        FormIssuTranfer,
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        index_page() {
            this.form = ""
            this.mutatesnackbar()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                }, 2000)
            }
        },
        get_issue() {
            this.form = "ISSUE"
        },
        get_transfer() {
            this.form = "TRANSFER"
        },
        get_transfer_ce() {
            this.form = "TRANSFER CE"
        },
        back() {
            this.form = ""
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
    },
    data() {
        return {
            form: "",
            text: "Success, Your work has been saved",
            team_name: localStorage.team_name,
            form_search_singlepart: "",
        }
    },
}
</script>

<style scoped>
.cursor {
    cursor: pointer;
}
.cursor:hover {
    color: #60b0d6;
}
</style>
